import Swiper, { Navigation, Pagination } from 'swiper';
import $ from 'jquery';
import { breakpoints } from 'js/config/breakpoints';

const slider = '.js-triple-box';
const sliderMainWrap = '.js-swiper-main-wrap';
const nextSlideNavEl = '.swiper-button-next';
const prevSlideNavEl = '.swiper-button-prev';
const slideNavBlock = '.swiper__navigate-block';
const pagination = '.swiper-pagination';
let swipers = [];
let windowWidth = 0;

function toggleNavigationView($slider) {
  const swiperDisabledClass = 'swiper-button-disabled';
  const mainWrap = $slider.closest(sliderMainWrap);
  const navBlock = mainWrap.find(slideNavBlock);
  const paginationBlock = mainWrap.find(pagination);
  const prevButton = navBlock.find(prevSlideNavEl);
  const nextButton = navBlock.find(nextSlideNavEl);
  if (prevButton.hasClass(swiperDisabledClass) && nextButton.hasClass(swiperDisabledClass)) {
    navBlock.hide();
    paginationBlock.hide();
  } else {
    navBlock.show();
    paginationBlock.show();
  }
}

function initSlider($slider) {
  const isKeyLinks = $slider.closest(sliderMainWrap).hasClass('triple-box--key-links');
  const swiper = new Swiper($slider[0], {
    modules: [Navigation, Pagination],
    loop: false,
    init: false,
    freeMode: false,
    spaceBetween: 24,
    centeredSlides: false,
    slidesPerView: 1,
    keyboard: true,
    pagination: {
      el: $slider.closest(sliderMainWrap).find(pagination)[0],
      clickable: true,
    },
    navigation: {
      nextEl: $slider.closest(sliderMainWrap).find(nextSlideNavEl)[0],
      prevEl: $slider.closest(sliderMainWrap).find(prevSlideNavEl)[0],
    },
    on: {
      transitionEnd: () => {
        $(document).trigger('slider-transition-end', {
          slider: this,
        });
      },
      resize: () => {
        toggleNavigationView($slider);
      },
      paginationRender: () => {
        $slider.closest(sliderMainWrap).find('.swiper-pagination-bullet').each(function (index) {
          const bullet = $(this);
          bullet.attr('id', index);
        });

        $slider.closest(sliderMainWrap).find('.swiper-pagination').each(() => {
          $slider.closest(sliderMainWrap).find('.swiper-pagination-bullet').attr('tabindex', 0);
          $slider.closest(sliderMainWrap).find('.swiper-pagination-bullet').on('keydown', function (event) {
            if (event.keyCode === 13) {
              const slideID = $(this).attr('id');
              swiper.slideTo(slideID);
            }
          });
        });
      },
    },
    breakpoints: {
      [breakpoints.md]: {
        slidesPerView: 2,
        spaceBetween: isKeyLinks ? 40 : 25,
      },
      [breakpoints.xl]: {
        allowTouchMove: false,
        slidesPerView: 3,
        spaceBetween: isKeyLinks ? 40 : 25,
      },
      1380: {
        allowTouchMove: false,
        slidesPerView: 3,
        spaceBetween: isKeyLinks ? 40 : 65,
      },
    },
  });

  swiper.init();
  swipers.push(swiper);
  toggleNavigationView($slider);
}

function init() {
  windowWidth = window.innerWidth;
  if ($(slider).length) {
    $(slider).each(function () {
      const isDesktopCards = windowWidth >= breakpoints.xl && $(this).hasClass('triple-box__list--desktop-cards-view');

      if (isDesktopCards) {
        $(this).closest(sliderMainWrap).find(slideNavBlock).hide();
        $(this).closest(sliderMainWrap).find(pagination).hide();
        return;
      }

      $(this).closest(sliderMainWrap).find(slideNavBlock).show();
      $(this).closest(sliderMainWrap).find(pagination).show();

      initSlider($(this));
    });
  }
}

function reInitSlider() {
  swipers.forEach((swiper) => {
    if (swiper && typeof swiper.destroy === 'function') {
      swiper.destroy();
    }
  });
  swipers = [];

  init();
}

$(document).ready(() => {
  init();
});

window.addEventListener('resize', () => {
  if (window.screen.width === windowWidth) {
    return;
  }

  reInitSlider();
});

window.addEventListener('orientationchange', () => {
  setTimeout(() => {
    reInitSlider();
  }, 500);
});